import Page from "@jumbo/shared/Page";
import ListSalesOrder from "app/pages/OrderProcessing/SalesOrders/ListSalesOrder";
import AuthenticateAndRolesMiddleware from "app/routes/Middleware";
import AuthenticateMiddleware from "app/routes/Middleware/AuthenticateMiddleware";


const routesName = "/dashboards/orderProcessing/salesOrder";
const modules = "salesOrder";




export const salesOrdersRoute = [
  {
    middleware: [
      {
        element: AuthenticateMiddleware,
        fallbackPath: {
          url: "/login",
        },
      },
    ],
    routes: [
      {
        middleware: [
          {
            element: AuthenticateAndRolesMiddleware,
            fallbackPath: {
              url: "/dashboard",
              module: "salesOrder",
              role: "view",
            },
          },
        ],
        routes: [
          {
            path: `${routesName}`,
            element: <Page component={ListSalesOrder} />,
          },
        ],
      },
      {
        middleware: [
          {
            element: AuthenticateAndRolesMiddleware,
            fallbackPath: {
              url: "/dashboard",
              module: "salesOrder",
              role: "add",
            },
          },
        ],
        routes: [
          {
            path: `${routesName}/add`,
            // element: <Page component={AddEditsalesOrder} />,
          },
        ],
      },
      {
        middleware: [
          {
            element: AuthenticateAndRolesMiddleware,
            fallbackPath: {
              url: "/dashboard",
              module: "salesOrder",
              role: "edit",
            },
          },
        ],
        routes: [
          {
            path: `${routesName}/edit`,
            // element: <Page component={AddEditCategory} />
          },
        ],
      },
    ],
  },
];